import { render, staticRenderFns } from "./active-edit-add.vue?vue&type=template&id=45bf83c0&scoped=true&"
import script from "./active-edit-add.vue?vue&type=script&lang=js&"
export * from "./active-edit-add.vue?vue&type=script&lang=js&"
import style0 from "./active-edit-add.vue?vue&type=style&index=0&id=45bf83c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf83c0",
  null
  
)

export default component.exports